<template>
  <div class="abnormal_list" v-loading="loading">
    <div v-if="list.length">
      <div class="abnormal_tit"><span>异常信息</span><span>处理信息</span></div>
      <div class="abnormal_item" v-for="item in list">
        <div class="abnormal_main" :class="item.toggleStatus ? 'up' : 'down'">
          <div>
            <div class="first_row">
              <div class="lable">
                <div>创建时间：</div>
                <div>{{ item.createTime }}</div>
              </div>
              <div class="lable">
                <div>来源人：</div>
                <div>
                  {{ item.sourceName || "/" }}
                  <span v-if="item.sourcePhone">{{ item.sourcePhone }}</span>
                  <el-button
                    v-if="item.sourceWorkerId"
                    class="btn"
                    @click="openCallModal(item)"
                    >站内电话</el-button
                  >
                </div>
              </div>
            </div>
            <div class="lable">
              <div>异常类型：</div>
              <div>{{ item.abnormalType_dictText }}</div>
            </div>
            <div class="lable">
              <div>异常描述：</div>
              <div>{{ item.description || "/" }}</div>
            </div>
            <div class="lable imgs" v-if="item.abnormalImage">
              <div>异常图片：</div>
              <div style="padding-top:10px">
                <template v-for="(it, index) in item.abnormalImage.split(',')">
                  <el-image
                    v-if="imgOrVideo(it).type == 'img'"
                    :key="index"
                    :src="imgOrVideo(it).url"
                    :preview-src-list="
                      setPreviewList(item.abnormalImage.split(','))
                    "
                  >
                  </el-image>
                  <el-image
                    style="cursor: pointer"
                    v-if="imgOrVideo(it).type == 'video'"
                    :key="index"
                    :src="imgOrVideo(it).url"
                    @click="openVideo(it)"
                  >
                  </el-image>
                  <audio
                    v-if="imgOrVideo(it).type == 'audio'"
                    controls
                    :src="imgOrVideo(it).url"
                  ></audio>
                  <a
                    v-if="imgOrVideo(it).type == 'download'"
                    :href="imgOrVideo(it).url"
                    target="_blank"
                    >媒体下载</a
                  >
                </template>
              </div>
            </div>
            <div class="lable imgs">
              <div>涉及商品：</div>
              <div>
                <div class="goods_imgs" v-for="it in item.orderItemList">
                  <el-image
                    :src="it.imgUrl"
                    :preview-src-list="item.orderItemList.map((i) => i.imgUrl)"
                  >
                  </el-image>
                  <div class="count">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="it.name"
                      placement="bottom"
                      popper-class="wuliutooltip"
                      :visible-arrow="false"
                    >
                      <span class="span">{{ it.name }}</span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="lable right_label" style="margin-top: 0">
              <div>处理状态：</div>
              <div>
                {{ setStatus(item.merchantStatus) }}
                <el-button class="btn" @click="handleException(item)"
                  >异常处理</el-button
                >
              </div>
            </div>
            <template
              v-if="
                item.orderAbnormalRecordList &&
                  item.orderAbnormalRecordList.length
              "
            >
              <div class="lable" v-for="it in item.orderAbnormalRecordList">
                <div>处理结果：</div>
                <div>
                  <div>
                    {{
                      new Date(Number(it.createTime)).format(
                        "yyyy-MM-dd HH:mm:ss"
                      )
                    }}
                    <span style="margin-left: 16px">{{ it.content }}</span>
                  </div>

                  <div v-if="it.image" style="width: 100%">
                    <el-image
                      v-for="i in it.image.split(',')"
                      :src="i"
                      :preview-src-list="it.image.split(',')"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="lable">
              <div>处理结果：</div>
              <div>未处理</div>
            </div>
          </div>
        </div>
        <div class="toggle" @click="onToggle(item)">
          <a-icon :type="item.toggleStatus ? 'up' : 'down'" />
        </div>
      </div>
    </div>
    <div v-else class="null-info">
      <img src="@/assets/img/pic_none.png" alt />
      暂无信息...
    </div>
    <videoCall-modal ref="videoCallModal"></videoCall-modal>
    <handleException-modal
      ref="handleExceptionModal"
      @ok="getList"
    ></handleException-modal>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import * as Constant from "@/utils/constant";
import videoCallModal from "@/components/user/modules/videoCallModal";
import handleExceptionModal from "./handleExceptionModal";
import { imgOrVideo } from "@/utils/util";
import videoPlay from "@/components/user/modules/videoPlay";

export default {
  data() {
    return {
      toggleStatus: true,
      loading: false,
      url: {
        list: "/order/api/abnormal/list",
      },
      followOptions: Constant.FOLLOW_TYPE,
      list: [],
    };
  },
  components: {
    videoCallModal,
    handleExceptionModal,
    videoPlay,
  },
  methods: {
    imgOrVideo,
    setPreviewList(list) {
      return list.map((i) => this.imgOrVideo(i).url);
    },
    // 播放视频
    openVideo(item) {
      console.log(item);
      this.$refs.videoPlay.init({ installVideoUrl: item });
    },
    onToggle(item) {
      item.toggleStatus = !item.toggleStatus;
      this.$forceUpdate();
    },
    // 异常处理
    handleException(item) {
      item.status = this.$parent.orderInfo.status;
      this.$refs.handleExceptionModal.add(item);
    },
    // 站内电话
    openCallModal(item) {
      console.log(item);
      let params = Object.assign({
        createBy: item.sourceName,
        createPhone: item.sourcePhone,
        applicantId: item.sourceWorkerId,
      });
      this.$refs.videoCallModal.init(
        Object.assign(params, {
          orderType: "applicant",
        })
      );
    },
    async getList() {
      this.list = [];
      this.loading = true;
      const { data } = await getAction(this.url.list, {
        pageIndex: 1,
        pageSize: 30,
        mainOrderId: this.$parent.orderid,
      });
      console.log(data);
      if (data.code == 0) {
        this.list = data.data.records || [];
        this.list.map((i) => {
          i.toggleStatus = false;
        });
      }
      this.loading = false;
    },
    setStatus(status) {
      for (let i of this.followOptions) {
        if (i.value == status) return i.label;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goods_imgs {
  position: relative;
  margin-right: 8px;
  margin-top: 10px;
  /deep/.el-image {
    margin-right: 0 !important;
    margin-top: 0 !important;
  }
  img {
    width: 80px;
    height: 80px;
    &:last-child {
      margin-right: 0;
    }
  }
  .count {
    position: absolute;
    width: 100%;
    height: 24px;
    background: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    bottom: 4px;
    left: 0;
    padding: 0 5px;
    .span {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
.abnormal_list {
  min-height: 408px;
  .abnormal_item {
    position: relative;
    margin-bottom: 11px;
    background: #fff;
    .toggle {
      width: 50px;
      height: 10px;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 0px 0px 100px 100px;
      position: absolute;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      left: calc(50% - 25px);
      bottom: -10px;
      &:hover {
        background: #3455d3;
      }
    }
  }
  .abnormal_tit {
    display: flex;
    background: #f9fafa;
    height: 36px;
    font-size: 12px;
    color: #5e6066;
    & > span {
      flex: 1 1;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
  .abnormal_main {
    display: flex;
    overflow: hidden;
    &.up {
      height: auto;
    }
    &.down {
      height: 104px;
    }
    .first_row {
      display: flex;
      align-items: center;
      .lable {
        margin-top: 0;
        & > div:last-child {
          width: auto;
          display: block;
        }
      }
      .lable + .lable {
        margin-left: 39px;
      }
    }
    & > div {
      padding: 20px;
      flex: 1 1;
      &:first-child {
        border-right: 1px solid #e8eef5;
      }

      .lable {
        position: relative;
        font-size: 12px;
        display: flex;
        margin-top: 10px;
        &.imgs {
          margin-top: 0;
          & > div:first-child {
            padding-top: 10px;
          }
        }
        /deep/.el-image {
          margin-right: 8px;
          margin-top: 10px;
          &:first-child {
            margin-left: 0;
          }
          &:nth-child(5n) {
            margin-right: 0;
          }
          img {
            width: 80px;
            height: 80px;
          }
        }
        & > div {
          color: #5e6066;
        }
        & > div:last-child {
          color: #2f3133;
          width: 438px;
          display: flex;
          flex-wrap: wrap;
        }
        .btn {
          position: absolute;
          top: 50%;
          margin-top: -14px;
          border-color: #dcdfe6;
          margin-left: 16px;
          &/deep/span {
            color: #5e6066;
            font-size: 12px;
          }
        }
        &.right_label {
          .btn {
            right: 0;
          }
        }
      }
    }
  }
  .null-info {
    background: #fff;
    padding: 30px 261px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #b4b7bc;
    margin-top: 15px;

    img {
      width: 375px;
      height: 94px;
      margin-bottom: 8px;
    }
  }
}
</style>
